// extracted by mini-css-extract-plugin
module.exports = {"KeyNumbers":"styles_KeyNumbers__IkVAa","keyNumber":"styles_keyNumber__0NUuc","text":"styles_text__Mi2FQ"};